import { IServiceResult, IUser } from "../Models/Models";

export interface IAuthentication {
  GetStatus(): Promise<IServiceResult<IUser>>;

  GetUser(): Promise<IServiceResult<IUser>>;
}
